var daylight_class = "white-vertion black-bg";
var midnight_class = "dark-vertion black-bg";
var body = document.getElementById("app-body");
var time = new Date().getHours();
if (time > 7 && time < 18) body.className = daylight_class;
else body.className = midnight_class;

/* Using reduce and Object.keys
With reduce and Object.keys to implement the desired filter (using ES6 arrow syntax):
Note that in the above code predicate must be an inclusion
condition(contrary to the exclusion condition the OP used),
so that it is in line with how Array.prototype.filter works.
*/
Object.filter = (obj, predicate) =>
	Object.keys(obj)
		.filter(key => predicate(obj[key]))
		.reduce((res, key) => ((res[key] = obj[key]), res), {});
